import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ArabicFlag } from '../../assets/icons/flag-icons/arabic.svg';
import { ReactComponent as EnglishFlag } from '../../assets/icons/flag-icons/english.svg';
import { ReactComponent as FrenchFlag } from '../../assets/icons/flag-icons/french.svg';
import { ReactComponent as SpanishFlag } from '../../assets/icons/flag-icons/spanish.svg';
import { ReactComponent as GlobeIcon } from '../../assets/icons/globe-icon.svg';
import { ReactComponent as UpArrowIcon } from '../../assets/icons/up-arrow.svg';
// import MyButton from '../../shared-components/button/Button';
import { getCookie, setCookie } from '../../shared-functions/Cookies';

const languages = [
  { code: 'en', short: 'EN', lang: 'english', Icon: EnglishFlag },
  { code: 'ar', short: 'AR', lang: 'arabic', Icon: ArabicFlag },
  { code: 'fr', short: 'FR', lang: 'french', Icon: FrenchFlag },
  { code: 'sp', short: 'SP', lang: 'spanish', Icon: SpanishFlag },
];

interface LanguageSelectorProperties {
  isCollapsed: boolean;
}

/**
 * Language Selector Component
 */
export default function LanguageSelector({ isCollapsed = false }: LanguageSelectorProperties) {
  const { t, i18n } = useTranslation('sharedComp');
  const [open, setOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState('en');

  // Load language from cookie or default to 'en'
  useEffect(() => {
    const savedLang = getCookie('i18next') || i18n.language || 'en';
    i18n.changeLanguage(savedLang);
    setCurrentLang(savedLang);
  }, [i18n]);

  /**
   * Change language and update cookie
   * @param {string} lng - Language code
   */
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setCookie('i18next', lng, null, null);
    setCurrentLang(lng);
    setOpen(false);
  };
  // useEffect(() => {
  //   const dirss = i18n.language === 'ar' ? 'rtl' : 'ltr';
  //   document.body.setAttribute('dir', dirss);
  // }, [i18n.language]);

  // const currentLangFullName = languages.find((l) => l.code === currentLang)?.lang || 'English';
  const currentLanguage = languages.find((l) => l.code === currentLang) || languages[0];
  // const headerLabel = `${currentLanguage.short}`;
  // const CurrentIcon = languages.find((l) => l.code === currentLang)?.Icon || GlobeIcon;

  useEffect(() => {
    const dirss = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.body.setAttribute('dir', dirss);
  }, [i18n.language]);

  return (
    <div className="language-selector">
      {/* <MyButton
        label={headerLabel}
        buttonType="gray"
        onClickFunc={() => setOpen(!open)}
        svgIcon={<CurrentIcon style={{ width: 24, height: 16, borderRadius: 2 }} />}
        svgBackIcon={<UpArrowIcon />}
      /> */}
      <div
        className={`language-trigger ${isCollapsed ? 'collapsed' : ''} ${open ? 'open' : ''}`}
        role="button"
        tabIndex={0}
        onClick={() => setOpen(!open)}
        onKeyDown={(event) => event.key === 'Enter' && setOpen(!open)}>
        <div className="left">
          <GlobeIcon className="globe-icon" />
          {!isCollapsed && <span className="label">{t('language')}</span>}
        </div>
        {!isCollapsed && (
          <div className="right">
            <currentLanguage.Icon className="selected-flag" />
            <span className="code">{currentLanguage.short}</span>
            <UpArrowIcon className={`arrow ${open ? 'open' : ''}`} />
          </div>
        )}
      </div>

      {open && (
        <div className={`dropdown-menu ${isCollapsed ? 'collapsed' : ''}`}>
          {languages.map((lng) => (
            <div
              key={lng.code}
              role="button"
              tabIndex={0}
              onClick={() => changeLanguage(lng.code)}
              onKeyDown={(even) => even.key === 'Enter' && changeLanguage(lng.code)}
              className={`menu-item ${lng.code === currentLang ? 'active' : ''}`}>
              <lng.Icon style={{ width: 24, height: 16, borderRadius: 2 }} />
              {t(lng.lang)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
